/** Recording Studio API — sessions, custom vocal sounds, recordings rename, and AI voice profiles from takes. */
import axios from "axios";
import { API } from "@/lib/creatorApi";

const http = axios.create({ baseURL: API, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const listRecSessions = () => data(http.get("/rec-studio/sessions"));
export const createRecSession = (body) => data(http.post("/rec-studio/sessions", body));
export const getRecSession = (id) => data(http.get(`/rec-studio/sessions/${id}`));
export const saveRecSession = (id, body) => data(http.put(`/rec-studio/sessions/${id}`, body));
export const deleteRecSession = (id) => data(http.delete(`/rec-studio/sessions/${id}`));

export const listCustomSounds = () => data(http.get("/rec-studio/presets"));
export const createCustomSound = (body) => data(http.post("/rec-studio/presets", body));
export const deleteCustomSound = (id) => data(http.delete(`/rec-studio/presets/${id}`));

/** Upload any audio file to Recordings, keeping its real file type. */
export function uploadRecording(blob, filename, label) {
  const fd = new FormData();
  fd.append("file", blob, filename);
  fd.append("label", label.slice(0, 160));
  return data(http.post("/recording/take", fd));
}

export const renameRecording = (id, label) => data(http.patch(`/recording/session/${id}`, { label }));
export const recordingIdFromUrl = (url) => (url.match(/\/api\/recording\/file\/([^/]+)\//) || [])[1] || null;

/** ElevenLabs voice clone from one WAV of the chosen takes, then a signature voice profile that uses it. */
export async function createVoiceFromTakes({ wav, name, style, gender }) {
  const fd = new FormData();
  fd.append("audio", wav, "studio-takes.wav");
  fd.append("name", name);
  fd.append("description", style || "");
  fd.append("consent_acknowledged", "true");
  const clone = await data(http.post("/voice/clone", fd));
  return data(http.post("/studio/voice_profiles", { name, style: style || `${name} — recorded in ELPM Recording Studio`, gender, cloned_voice_id: clone.voice_id }));
}

export const absUrl = (u) => (u?.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export const TRACK_KINDS = [
  { key: "lead", label: "Lead vocal" },
  { key: "harmony", label: "Harmony" },
  { key: "adlib", label: "Ad-libs" },
  { key: "choir", label: "Choir" },
  { key: "speech", label: "Spoken / preaching" },
];

const SETUP_KEY = "elpm-rec-setup";
export function loadSetup() {
  try { return JSON.parse(localStorage.getItem(SETUP_KEY) || "null") || {}; } catch { return {}; }
}
export function saveSetup(patch) {
  const next = { ...loadSetup(), ...patch, at: new Date().toISOString() };
  try { localStorage.setItem(SETUP_KEY, JSON.stringify(next)); } catch { /* private mode */ }
  return next;
}
